const RED_COLOR = '#F03A17';
const GREEN_COLOR = '#13A10E';
const GRAY_COLOR = '#333333';

const findByProp = (items, prop, value) => {
	for (let each of items) {
		if (each[prop] === value) {
			return each;
		}
	}
}

const pluralize = (value, one, two, many) => {
	if (Math.floor(value) != value) {
		return many;
	}
	let new_value = value;
	if (value < 0) {
		new_value = -value;
	}
	let firstDigit = new_value - Math.floor(new_value / 10) * 10;
	let twoDigits = new_value - Math.floor(new_value / 100) * 100;
	if (twoDigits >= 11 && twoDigits <= 19) {
		return many;
	}
	if (firstDigit == 1) {
		return one;
	}
	else if (firstDigit >= 2 && firstDigit <= 4) {
		return two;
	}
	return many;
};

const isValidDate = dateString => {
	if (!/^\d{1,2}\.\d{1,2}\.\d{4}$/.test(dateString)) {
		return false;
	}
	var parts = dateString.split('.');
	var day = parseInt(parts[0], 10);
	var month = parseInt(parts[1], 10);
	var year = parseInt(parts[2], 10);
	if (year < 1900 || year > 2023 || month == 0 || month > 12) {
		return false;
	}
	var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
		monthLength[1] = 29;
	}
	return day > 0 && day <= monthLength[month - 1];
};

const arrayRange = (start, stop) => Array.from(
	{ length: stop - start },
	(value, index) => start + index
);

export {
	findByProp,
	pluralize,
	isValidDate,
	arrayRange,
	RED_COLOR,
	GREEN_COLOR,
	GRAY_COLOR,
}
